export const CHANGE_PAYMENT_DATA = "CHANGE_PAYMENT_DATA";
export const LOADING_BTN_PAYMENT = "LOADING_BTN_PAYMENT";
export const SET_IS_PAYMENT_ORDER_FLOW = 'SET_IS_PAYMENT_ORDER_FLOW';